import { NitroModules } from "react-native-nitro-modules";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneLaunchScreen");
  return hybrid;
}
var LaunchScreen = Object.freeze({
  preventAutoHide() {
    native().preventAutoHide();
  },
  hide(options) {
    var _ref;
    native().hide((_ref = options === null || options === void 0 ? void 0 : options.fade) !== null && _ref !== void 0 ? _ref : false);
  }
});
export {
  LaunchScreen
};
//# sourceMappingURL=index.native.js.map
